import { defineNuxtPlugin } from "#app";

/**
 * Client side basket plug in
 */
export default defineNuxtPlugin( {
  name: "apollo-basket-client",
  parallel: true,
  async setup ( nuxtApp ) {
    const basketStore = useBasketStore();

    nuxtApp.hook( "apollo:auth:signin", async () => {
      // When the user signs in, reload the client side basket
      await basketStore.refreshBasket();
    } );

    nuxtApp.hook( "apollo:auth:signout", async () => {
      // When the user signs out, we need to clear out the basket store
      basketStore.removeClientBasket();
    } );

    nuxtApp.hook( "apollo:auth:switch", async ( oldAccount, newAccount ) => {
      // When the user switches accounts, clean up the client site basket

      // Remove the current client side basket
      basketStore.removeClientBasket();

      // If a new account has been logged in, then we need to refresh the client basket
      if ( newAccount ) {
        await basketStore.refreshBasket();
      }
    } );

    basketStore.connectToStream();
  },
} );
